// extracted by css-extract-rspack-plugin
export default {"checkbox":"makeRowsSelectable_checkbox__TYLS2","checked":"makeRowsSelectable_checked__TGxZU"};